import setTableIsInCheckedMode from './mutators/setTableIsInCheckedMode';
import setFocusedRowKey from './mutators/setFocusedRowKey';
import singleSelectRowInternal from './singleSelectRowInternal';
import { setSelectionOnRow } from 'owa-mail-actions/lib/mailListSelectionActions';
import resetSelectionInternal from './resetSelectionInternal';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import setSelectionAnchorRowKey from './mutators/setSelectionAnchorRowKey';
import setMultiSelectionAnchorRowKey from './mutators/setMultiSelectionAnchorRowKey';
export default function rangeSelectRowInternal(tableView, targetRowKey, mailListItemSelectionSource, isCtrlKeyDown) {
    if (isMailFeatureEnabled('tri-selectionRefactor')) {
        rangeSelectRow(tableView, targetRowKey, mailListItemSelectionSource, isCtrlKeyDown);
    }
    else {
        rangeSelectRowLegacy(tableView, targetRowKey, mailListItemSelectionSource, isCtrlKeyDown);
    }
}
function rangeSelectRow(tableView, targetRowKey, mailListItemSelectionSource, isCtrlKeyDown) {
    // If user shift-clicks the same row as the multiSelectionAnchor, assume they want to open the item
    if (targetRowKey === tableView.multiSelectionAnchorRowKey) {
        singleSelectRowInternal(tableView, targetRowKey, true /* isUserNavigation */, mailListItemSelectionSource);
        return;
    }
    var rangeSelectionAnchor = tableView.multiSelectionAnchorRowKey
        ? tableView.multiSelectionAnchorRowKey
        : tableView.selectionAnchorRowKey || tableView.rowKeys[0];
    // For the shift click scenario
    var rangeBoundaries = [rangeSelectionAnchor, targetRowKey];
    // Selection path is the collection of rows that should be selected after range select (if row is in the path it should be selected, otherwise it should not be)
    var inSelectionPath = false;
    // Boundary means a row is on a boundary of the selection path
    var isBoundary = false;
    var currentRowKey;
    for (var i = 0; i < tableView.rowKeys.length; i++) {
        currentRowKey = tableView.rowKeys[i];
        isBoundary = rangeBoundaries.includes(currentRowKey);
        // If row is not within bounds of the selection, deselect it if it is selected and the ctrl key isn't down
        if (!inSelectionPath && !isBoundary) {
            if (isSelected(tableView, currentRowKey) && !isCtrlKeyDown) {
                setSelectionOnRow(currentRowKey, tableView.id, false /* shouldSelect */);
            }
        }
        else {
            // If we come across first boundary of selection, set the selection path to true so subsequent rows get selected
            // If we come across the second boundary of selection, set the selection path to false so subsequent rows don't get selected
            inSelectionPath = isBoundary !== inSelectionPath;
            setSelectionOnRow(currentRowKey, tableView.id, true /* shouldSelect */);
        }
    }
    setMultiSelectionAnchorRowKey(tableView, rangeSelectionAnchor);
    setSelectionAnchorRowKey(tableView, targetRowKey);
    setFocusedRowKey(tableView, targetRowKey);
    setTableIsInCheckedMode(tableView, true);
}
function isSelected(tableView, rowKey) {
    return tableView.selectedRowKeys.has(rowKey);
}
function rangeSelectRowLegacy(tableView, targetRowKey, mailListItemSelectionSource, isCtrlKeyDown) {
    if (targetRowKey === tableView.selectionAnchorItemId) {
        singleSelectRowInternal(tableView, targetRowKey, true /* isUserNavigation */, mailListItemSelectionSource);
        return;
    }
    // Clear the previous selection if ctrl key isn't down
    if (!isCtrlKeyDown) {
        resetSelectionInternal(tableView);
    }
    setTableIsInCheckedMode(tableView, true);
    var rangeBoundaries = [tableView.selectionAnchorItemId || tableView.rowKeys[0], targetRowKey];
    for (var i = 0; i < tableView.rowKeys.length; i++) {
        // Search through the table until we find one of the two range boundaries.
        // Then, selectItems() will mark items as selected until it finds the other range boundary
        if (rangeBoundaries.includes(tableView.rowKeys[i])) {
            selectItems(tableView, i, rangeBoundaries[0] === tableView.rowKeys[i]
                ? rangeBoundaries[1]
                : rangeBoundaries[0], mailListItemSelectionSource);
            break;
        }
    }
}
function selectItems(tableView, startingIndex, endingRowKey, mailListItemSelectionSource) {
    for (var i = startingIndex; i < tableView.rowKeys.length; i++) {
        setSelectionOnRow(tableView.rowKeys[i], tableView.id, true /* shouldSelect */);
        if (tableView.rowKeys[i] === endingRowKey) {
            return;
        }
    }
}
//# sourceMappingURL=rangeSelectRowInternal.js.map